<!--
 * @Descripttion:
 * @Author: sch
 * @LastEditTime: 2022-03-28 15:59:59
-->
<!-- components/Qqmap.vue -->
<template>
  <div class="map">
    <div class="top_nav">
      <p class="p_lf" @click="$emit('hideMap')">返回</p>
      <!-- <p>选择地址</p> -->
      <p class="p_rt" @click="selectSite">确定</p>
    </div>
    <iframe id="mapPage" width="100%" height="100%" frameborder="0" :src="getSrc"></iframe>
  </div>
</template>
<script>
import { NavBar } from 'vant'
export default {
  name: 'QqMap',
  components: {
    NavBar
  },
  data() {
    return {
      locData: ''
    }
  },
  computed: {
    getSrc() {
      var baseUrl =
        'https://apis.map.qq.com/tools/locpicker?search=1&type=1&policy=1&coordtype=5&key=' +
        this.mapKey +
        '&referer=' +
        this.keyName
      if (this.lat && this.lng) {
        baseUrl += `&coord=${this.lat},${this.lng}`
      }
      return baseUrl
    }
  },
  props: {
    mapKey: {
      type: String,
      default: '526BZ-5VR6U-26ZVZ-42EA5-66IWZ-UFBX5'
    },

    keyName: {
      type: String,
      default: 'mysite'
    },
    lat: {
      type: [String, Number]
    },
    lng: {
      type: [String, Number]
    }
  },

  mounted() {
    var self = this
    localStorage.setItem('goMap', '1')
    window.addEventListener(
      'message',
      function (event) {
        // 对于无法识别的地址，直接返回无法选择
        var loc = event.data
        if (loc.poiname === '我的位置' || loc.poiaddress === '') {
          self.$toast('无法识别该地址，请移动地图重新选择')
          return false
        }
        if (loc && loc.module === 'locationPicker') {
          // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          console.log('loc', loc)
          self.locData = loc
        }
      },
      false
    )
  },
  methods: {
    selectSite() {
      let self = this
      self.$emit('callback', self.locData)
    }
  }
}
</script>

<style lang="scss" scoped>
.top_nav {
  font-size: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  height: 35px;
  line-height: 35px;
  .p_lf {
    color: #1989fa;
    padding-left: 16px;
  }
  .p_rt {
    color: #1989fa;
    padding-right: 16px;
  }
}
.map {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Qqmap.vue